/* eslint-disable @typescript-eslint/consistent-type-assertions */
import type {
  Image,
  RetweetMedia,
  Video,
} from '~publish/legacy/composer/composer/entities/factories'

import { parseTwitterLinks } from '~publish/legacy/utils/channels/twitter/helpers'
import { AttachmentVideo } from '../AttachmentVideo'
import * as Styles from './styles'
import type { LinkType } from '~publish/legacy/shared-components/LinkifiedText/LinkifiedText'

interface AttachmentRetweetData {
  avatarUrl: string
  userName: string
  userDisplayName: string
  text: string
  media?: RetweetMedia[]
}

const AttachmentRetweet = ({
  data,
}: {
  data: AttachmentRetweetData
}): JSX.Element => {
  const { avatarUrl, userName, userDisplayName, text, media } = data

  // Process media for display
  const images: Image[] = []
  let video: Video | null = null

  if (media && media.length > 0) {
    media.forEach((mediaItem) => {
      if (mediaItem.type === 'photo') {
        images.push({
          url: mediaItem.url,
          width: mediaItem.width,
          height: mediaItem.height,
          altText: null,
          source: null,
          mediaType: 'image',
          originalUrl: null,
        })
      } else if (
        mediaItem.type === 'video' ||
        mediaItem.type === 'animated_gif'
      ) {
        // For videos, create a video object with thumbnail
        video = {
          uploadId: mediaItem.id,
          name: mediaItem.type === 'animated_gif' ? 'GIF' : 'Video',
          duration: mediaItem.duration_ms ? mediaItem.duration_ms / 1000 : 0,
          durationMs: mediaItem.duration_ms || 0,
          size: 0,
          width: mediaItem.width,
          height: mediaItem.height,
          url: mediaItem.url,
          originalUrl: mediaItem.url,
          thumbnail: mediaItem.url, // Use the thumbnail URL
          availableThumbnails: [mediaItem.url],
          thumbOffset: 0,
          mediaType: 'video',
        }
      }
    })
  }

  const hasImages = images.length > 0
  const hasVideo = video !== null

  return (
    <Styles.Wrapper data-testid="twitter-preview-retweet">
      <Styles.UserWrapper>
        <Styles.Avatar src={avatarUrl} alt={`${userName}'s avatar`} />
        <Styles.DisplayName>{userDisplayName}</Styles.DisplayName>
        <Styles.Username>@{userName}</Styles.Username>
      </Styles.UserWrapper>
      <Styles.LinkifiedText
        links={parseTwitterLinks(text) as LinkType[]}
        size="mini"
        whitespace="pre-wrap"
        newTab
      >
        {text}
      </Styles.LinkifiedText>
      {hasImages && (
        <Styles.ImagesGrid
          images={images}
          isRowFormat={false}
          maxHeight="150px"
          shouldShowGifTag={false}
        />
      )}
      {hasVideo && video && <AttachmentVideo video={video} />}
    </Styles.Wrapper>
  )
}

export { AttachmentRetweet }
